export default __webpack_public_path__ + "static/media/amhi-logo.4ab64868.png";